// A separator can straddle a chunk boundary and servers vary between LF and CRLF, so
// the buffer is only consumed once a whole separator is present.
const FRAME_SEPARATOR = /\r?\n\r?\n/;
const LINE_BREAK = /\r?\n/;

const parseFrame = (raw) => {
  let event = "message";
  let hasField = false;
  const dataLines = [];

  for (const line of raw.split(LINE_BREAK)) {
    if (!line || line.startsWith(":")) continue;

    const colon = line.indexOf(":");
    const field = colon === -1 ? line : line.slice(0, colon);
    let value = colon === -1 ? "" : line.slice(colon + 1);
    if (value.startsWith(" ")) value = value.slice(1);

    hasField = true;
    if (field === "event") event = value;
    else if (field === "data") dataLines.push(value);
  }

  return hasField ? { event, data: dataLines.join("\n") } : null;
};

export const createSseParser = () => {
  let buffer = "";

  const drain = () => {
    const frames = [];
    let separator;

    while ((separator = FRAME_SEPARATOR.exec(buffer))) {
      const frame = parseFrame(buffer.slice(0, separator.index));
      buffer = buffer.slice(separator.index + separator[0].length);
      if (frame) frames.push(frame);
    }

    return frames;
  };

  const push = (chunk) => {
    buffer += chunk;
    return drain();
  };

  // A server that closes right after writing its last frame may omit the trailing
  // blank line, so the leftover buffer is parsed as one final frame.
  const flush = () => {
    const frames = drain();
    const trailing = buffer.trim() ? parseFrame(buffer) : null;
    buffer = "";
    if (trailing) frames.push(trailing);
    return frames;
  };

  return { push, flush };
};
